import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Checkbox } from 'semantic-ui-react';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';

import Modal from "../../ui/Modals/ModalWindow";
import Spinner from "../../ui/Spinner/Spinner";
import Subquestion from "./Subquestion/Subquestion";
import RequireAuth from "../../layout/HOC/require-auth";

import "./QuestionInfo.scss";

import {
  getQuestionInfoAsync,
  deleteQuestionAsync,
  sortChildrenAsync,
  changeQuestionVisibilityAsync,
} from "../../../redux/actions/questionInfo";

import {
  openDeleteQuestionModal,
  closeDeleteQuestionModal
} from "../../../redux/actions/ui";

const SortableItem = sortableElement(({question}) => (
  <Subquestion
    key={`${question.id}_${question.index}`}
    item={question}
    index={question.index}
  />
));

const SortableContainer = sortableContainer(({children}) => {
  return <div className="childrens-wrap">{children}</div>;
});

const mapStateToProps = state => ({
  ...state.questionInfo,
  deleteQuestionModal: state.ui.deleteQuestionModal,
});

const mapDispatchToProps = dispatch => ({
  onGoBack: () => dispatch(push('/questions')),
  getQuestionInfo: questionId => dispatch(getQuestionInfoAsync(questionId)),
  onEditQuestion: questionId => dispatch(push(`/edit-question/${questionId}`)),
  onDeleteQuestion: questionId => dispatch(deleteQuestionAsync(questionId)),
  openDeleteModal: () => dispatch(openDeleteQuestionModal()),
  closeDeleteModal: () => dispatch(closeDeleteQuestionModal()),
  onSortChildren: ({oldIndex, newIndex}) => dispatch(sortChildrenAsync({oldIndex, newIndex})),
  onChangeQuestionVisibility: (status, questionId) => dispatch(changeQuestionVisibilityAsync(status, questionId)),
});

class QuestionInfo extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    onGoBack: PropTypes.func.isRequired,
    question: PropTypes.object.isRequired,
    onEditQuestion: PropTypes.func.isRequired,
    onSortChildren: PropTypes.func.isRequired,
    getQuestionInfo: PropTypes.func.isRequired,
    onDeleteQuestion: PropTypes.func.isRequired,
    deleteQuestionModal: PropTypes.object.isRequired,
    onChangeQuestionVisibility: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { getQuestionInfo } = this.props;
    const questionId= this.props.match.params.questionId;
    getQuestionInfo(questionId); 
  }

  //Список подвопросов с возможностью drag and drop
  renderSubquestions = (question, i) => {
    question.index = i;
    return(
      <SortableItem key={`item-${question.id}`} index={i} question={question} />
    );
  }

  render() {
    const {
      ready,
      loading,
      question,
      onGoBack,
      onEditQuestion,
      onDeleteQuestion,
      deleteQuestionModal,
      openDeleteModal,
      closeDeleteModal,
      onSortChildren,
      onChangeQuestionVisibility,
    } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          heading="Вы уверены, что хотите удалить вопрос?"
          confirmText="Отмена"
          cancelText="Удалить"
          modal={deleteQuestionModal}
          onSubmit={() => closeDeleteModal()}
          onCancel={() => onDeleteQuestion(question.id)}
        />
        {ready ? (
          <React.Fragment>
            <div className="page-header">
              <button type="button" className="btn btn-back" onClick={() => onGoBack()}>
                <i aria-hidden="true" className="back-icon icon" />
                <span>Назад</span>
              </button>
            </div>
          
            <div className="page-content forms question">
              <div className="poll-header">
                {/* Редактирование и удаление основного вопроса */}
                <div className="poll-btns">
                  <button
                    type="button"
                    className="btn btn-green edit-size"
                    onClick={() => onEditQuestion(question.id)}
                  >
                    Редактировать
                  </button>
                  <button
                    type="button"
                    className="btn btn-red del-size"
                    onClick={() => openDeleteModal()}
                  >
                    Удалить
                  </button>
                </div>
                {/* Изменение видимости основного вопроса */}
                <div className="checkboxes-wrap">
                  <Checkbox
                    label='Скрыть вопрос'
                    checked={!question.is_visible}
                    onChange={() => onChangeQuestionVisibility(!question.is_visible, question.id)}
                  />
                </div>
              </div>
              <div className="title-wrap">
                <h1 className="page-title">{question.header}</h1>
              </div>
              <div className="question-text">{question.answer}</div>
              {question.children.length !== 0 ? (
                <SortableContainer
                  useDragHandle
                  helperClass="isDragged"
                  onSortEnd={onSortChildren}
                >
                  {question.children.map(this.renderSubquestions)}
                </SortableContainer>
              ) : false}
              <div className="content-info">
                {(question.role === 'consultant') ?
                  (<div className="content-for consultants">Для консультантов</div>)
                : false}
                {(question.role === 'client')?
                  (<div className="content-for clients">Для клиентов</div>)
                : false}
              </div>
            </div>
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(QuestionInfo));
